import { render, staticRenderFns } from "./UnvergessenButton.vue?vue&type=template&id=3df3a378"
import script from "./UnvergessenButton.vue?vue&type=script&lang=js"
export * from "./UnvergessenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports